export default __webpack_public_path__ + "static/media/hypergate_pro.8f252b6f.png";